import { Link } from '@spotify-internal/encore-web';

import {
  TransitionScreen,
  transitionActionLinkClassNames,
} from '../TransitionScreen';
import { emailLink } from '../utils';

export const InviteError = ({ error }: { error: Error }) => {
  const inviteNotFound = error.message.includes('was not found');

  return (
    <TransitionScreen
      title={
        inviteNotFound
          ? "Sorry, we couldn't find that invite"
          : 'Something went wrong'
      }
      description={
        inviteNotFound
          ? 'Try clicking on the link that you received in your invitation email. If you still end up here, please contact us for support.'
          : 'We seem to be experiencing some trouble on our end. Try refreshing the page or contact us to help you figure out the next step.'
      }
      actions={
        <Link
          href={emailLink('Account invite issue', error.message)}
          className={transitionActionLinkClassNames.primary}
        >
          Contact support
        </Link>
      }
    />
  );
};
